module.exports = "/* You can add global styles to this file, and also import other style files */"